export const global_TimingFunction = {
  "name": "--pf-global--TimingFunction",
  "value": "cubic-bezier(0.645, 0.045, 0.355, 1)",
  "var": "var(--pf-global--TimingFunction)"
};
export default global_TimingFunction;